import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductCardSkuItemParams {
  distributor_id: number;
  inventory_id: number;
  position: number;
  product_id: number;
  deal_tag: boolean;
  verified_in_stock?: boolean;
  price_schedule_available?: boolean;
}
export class ProductCardSkuItemEntity extends BaseEntityClass {
  distributor_id: number;
  inventory_id: number;
  product_id: number;
  position: number;
  deal_tag: boolean;
  verified_in_stock?: boolean;
  price_schedule_available?: boolean;

  constructor(params: ProductCardSkuItemParams) {
    super();
    this.type = "product_card_sku_item";
    this.entity_version = 7;
    this.distributor_id = params.distributor_id;
    this.inventory_id = params.inventory_id;
    this.position = params.position;
    this.product_id = params.product_id;
    this.deal_tag = params.deal_tag;
    this.verified_in_stock = params.verified_in_stock;
    this.price_schedule_available = params.price_schedule_available;
  }
}
